<template>
  <div>
    <h4 class="">Gerenciamento de Usuários</h4>
    <div class="mb-2 mt-3 d-flex" style="gap: 12px">
      <SGPFormSelectComponent :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados" :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
        :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
        :optionSelecione="'Não'" @change="filtrarUsuariosDeletados($event)" />
      <SGPFormSelectComponent :name="'semModulo'" :listaDeOptions="opcoesSemModulo"
        v-model="semModulo" :optionLabel="'nome'" :placeholder="'Sem módulo'"
        :optionSelecione="'Todos'" @change="aplicarFiltros()" />
    </div>

    <!-- <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listaDeUsuarios && listaDeUsuarios.length"
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao"
    > -->
    <SGPTabelaAvancadaComponent v-if="listaDeUsuarios && listaDeUsuarios.length" :colunas="colunas"
      :dados="usuariosTratados" :key="tabelaKey" usuarioPodeExcluir
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados" @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados" @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
      selecionarColunas :filtroText="true">
      <template v-slot:item.modulos_list="{ item }">
        <div v-if="item.modulos_list && item.modulos_list.length" style="display: flex; flex-wrap: wrap; gap: 4px; max-width: 260px;">
          <v-chip v-for="mod in item.modulos_list" :key="mod.id" x-small color="primary" outlined>
            {{ mod.nome }}
          </v-chip>
        </div>
        <span v-else>—</span>
      </template>
      <template v-slot:item.selecionar="{ item }">
        <div class="container-botao-tabela">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn fab x-small color="info" class="mr-1" v-on="on"
                @click="$router.push({ name: 'usuario-modulos', params: { usuario: item.id } })">
                <v-icon small color="white">mdi-folder-account-outline</v-icon>
              </v-btn>
            </template>
            <span>Gerenciar módulos</span>
          </v-tooltip>
          <v-btn fab x-small color="warning" class="mr-1"
            :disabled="!!item.deleted_at"
            @click="editarUsuario(item)">
            <v-icon small color="white">mdi-pencil</v-icon>
          </v-btn>
          <v-btn fab x-small color="primary"
            :disabled="!!item.deleted_at"
            @click="excluirUsuario(item)">
            <v-icon small color="white">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </SGPTabelaAvancadaComponent>
    <!-- </SGPPaginacaoComponent>   -->
    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent v-if="abrirModal" tamanho="sm" titulo="Usuário" @sgpModalFechar="fecharModal"
      :mostrarFooter="false">
      <FormularioUsuarioComponent :tipoFormulario="tipoFormulario" :usuario="usuario" @usuarioAtualizado="atualizarListaUsuarios" />
    </SGPModalComponent>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoUsuario" />

    <v-tooltip left>
      <template #activator="{ on }">
        <v-btn
          fab
          dark
          color="primary"
          style="position: fixed; bottom: 90px; right: 30px; z-index: 5;"
          v-on="on"
          @click="abrirModalImportar = true"
        >
          <v-icon>mdi-file-import-outline</v-icon>
        </v-btn>
      </template>
      <span>Importar usuários</span>
    </v-tooltip>

    <ImportarUsuariosModal
      v-if="abrirModalImportar"
      @fechar="abrirModalImportar = false"
      @concluido="onImportacaoConcluida"
    />

    <SGPConfirmacaoDelecaoComponent v-if="abrirModalDeletarDados" @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()" />
    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FormularioUsuarioComponent from "../components/FormularioUsuarioComponent.vue";
import ImportarUsuariosModal from "../components/ImportarUsuariosModal.vue";
import deletar from "@/././common/mixins/deletar.js";

export default {
  components: { FormularioUsuarioComponent, ImportarUsuariosModal },
  name: "UsuarioPage",

  data() {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      usuariosSelecionados: [],
      abrirModal: false,
      tipoFormulario: "salvar",
      tabelaKey: 0,
      usuario: {},
      opcoesSelect: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      opcoesSemModulo: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      exibirItensDeletados: '',
      semModulo: '',
      abrirModalImportar: false,
    };
  },
  mixins: [deletar],

  watch: {
    trocandoModulo(val) {
      if (val === false) {
        this.listarUsuarios({
          exibirItensDeletados: this.exibirItensDeletados,
          semModulo: this.semModulo
        }).then(() => { this.tabelaKey += 1; });
      }
    }
  },

  created() {
    this.listarUsuarios({
      exibirItensDeletados: this.exibirItensDeletados,
      semModulo: this.semModulo
    });
  },

  computed: {
    ...mapGetters("usuarios", ["listaDeUsuarios", "loadingUsuario"]),
    ...mapGetters("ctrlModulos", ["trocandoModulo"]),

    usuariosTratados() {
      if (!this.listaDeUsuarios) return [];

      return this.listaDeUsuarios.map(u => ({
        ...u,
        provedor_nome: u.ctrl_provedores?.[0]?.nome || '—',
        modulos_list: u.modulos || []
      }));
    },

    // paginacao () {
    //   if (!this.listaDeUsuarios.data) return {}

    //   const paginate =  {
    //     per_page: this.listaDeUsuarios.per_page,
    //     total: this.listaDeUsuarios.total,
    //     current_page: this.listaDeUsuarios.current_page
    //   }

    //   return {
    //     per_page: paginate.per_page,
    //     total: paginate.total,
    //     current_page: paginate.current_page
    //   }
    // },

    colunas() {
      return [
        {
          key: "name",
          label: "Nome",
          sortable: false,
        },
        {
          key: "email",
          label: "E-mail",
          sortable: false,
        },
        {
          key: "provedor_nome",
          label: "Provedor",
          sortable: false,
        },
        {
          key: "modulos_list",
          label: "Módulos",
          sortable: false,
        },
        {
          key: 'restaurar',
          label: 'Restaurar'
        },
        {
          key: "selecionar",
          label: "Ações",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    ...mapActions("usuarios",
      [
        "listarUsuarios",
        "listarUsuariosComPaginacao",
        "deletarUsuario",
        "restaurarUsuario"
      ]),

    gerenciadorDeSelecionados(selecionados) {
      this.usuariosSelecionados = selecionados;
    },

    adicionarNovoUsuario() {
      this.abrirModal = true;
      this.tipoFormulario = "salvar";
      this.usuario = {};
    },

    editarUsuario(item) {
      this.tipoFormulario = "editar";
      this.usuario = item;
      this.abrirModal = true;
    },

    excluirUsuario(item) {
      this.usuariosSelecionados = [item];
      this.abrirModalDeletarDados = true;
    },

    editarSelecionado() {
      this.tipoFormulario = "editar";
      this.usuario = this.usuariosSelecionados[0];
      this.abrirModal = true;
    },

    restaurarSelecionado(item) {
      this.restaurarUsuario(item.id);
    },

    confirmarDelecao() {
      this.deletarDados = false;
      this.abrirModalDeletarDados = false;

      this.usuariosSelecionados.forEach(async (usuario) => {
        await this.deletarUsuario(usuario);
      });
    },

    fecharModal() {
      this.abrirModal = false;
    },

    async atualizarListaUsuarios() {
      await this.listarUsuarios({
        exibirItensDeletados: this.exibirItensDeletados,
        semModulo: this.semModulo
      });
      this.tabelaKey += 1;
    },

    aplicarFiltros() {
      this.listarUsuarios({
        exibirItensDeletados: this.exibirItensDeletados,
        semModulo: this.semModulo
      }).then(() => { this.tabelaKey += 1; });
    },

    filtrarUsuariosDeletados(event) {
      if (typeof event == 'undefined') return false;
      this.aplicarFiltros();
    },

    reloadData() {
      this.listarUsuarios({
        exibirItensDeletados: this.exibirItensDeletados,
        semModulo: this.semModulo
      });
    },

    async onImportacaoConcluida() {
      this.abrirModalImportar = false;
      await this.atualizarListaUsuarios();
    },

    // async realizarPaginacao (paginacao) {
    //   let payload = {
    //     ...paginacao,
    //     exibirItensDeletados: this.exibirItensDeletados
    //   }

    //   await this.listarUsuariosComPaginacao(payload);
    //   this.abrirFiltroAvancado = false;
    // },
  },
};
</script>
